import React, { useState } from "react";
import { useIntl } from "react-intl";
import ReactGA from "react-ga4";
import * as ReactDOM from "react-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {
  Banner,
  Content,
  Button,
  Icon,
  ReadyToStart,
  Tarifas,
  Layout,
  Convertion,
  ConvertionBelow,
  List,
  ItemList,
  AnimateIcon,
  Bubble,
} from "../../components";
import useAppContext from "../../context/Context";
import { paymentLink } from "../../services/animationIcons";
import "./PaymentLinks.scss";
import Modal from "../../components/Modal/Modal";
import { TarifasPaymentLink } from "../../components/Tarifas/TarifasPaymentLink";
import CardStep from "../../components/CardStep/CardStep";
import EasyGestion from "../../components/EasyGestion/EasyGestion";

gsap.registerPlugin(ScrollTrigger);
export const PaymentLinks = () => {
  const { activeCountry } = useAppContext();

  ReactGA.send({ hitType: "pageview", page: "/payment-links" });

  const { setStep, getImages } = useAppContext();
  const intl = useIntl();
  const color = "#857BF9";

  React.useEffect(() => {
    setStep && setStep(1);
  }, []);

  const [openModal, setOpenModal] = useState(false);

  const changeModal = () => {
    setOpenModal(!openModal);
  };

  return (
    <Layout title="Genera enlaces de pago" className="payment-link">
      {openModal === true &&
        ReactDOM.createPortal(
          <Modal
            changeModal={changeModal}
            content={
              <iframe
                className="iframe"
                src={
                  activeCountry === "mx"
                    ? "https://share.hsforms.com/14Hl-W1oeQx-uUbcs4v0x5A5l986"
                    : "https://share.hsforms.com/1nESwD7ncTxK4ewZnR1u7yQ5l986"
                }
                frameborder="0"
              ></iframe>
            }
          ></Modal>,
          document.getElementById("portal")
        )}

      <Banner
        customClass="banner-quick"
        background={getImages["banner_background_payment"]}
      >
        {activeCountry === "mx" ? (
          <Content
            flag={"Primer mes gratis, por tiempo limitado"}
            content={
              <div className="banner-top-icon">
                <div>
                  <AnimateIcon json={paymentLink} />
                </div>
                <p>Payment Links</p>
              </div>
            }
            title={intl.formatMessage({ id: "banner.payment.title" })}
            subtitle={intl.formatMessage({ id: "banner.payment.subtitle" })}
            footer={
              <>
                <a href="https://dashboard.etpay.com/sign-up">
                  <Button
                    bgColor={"#857BF9"}
                    bgHoverColor="#140F33"
                    color="#fff"
                  >
                    <Icon name={"Icon_Pre"} className="fillable" fill="#fff" />
                    <span>
                      {intl.formatMessage({ id: "button.testFree.text" })}
                    </span>
                  </Button>
                </a>
                <p>
                  o llámanos al{" "}
                  {activeCountry === "mx"
                    ? "+52 55 4169 7254"
                    : "+56 2 3210 1557"}
                </p>

                {/* <a href={
                'tel:' + intl.formatMessage({ id: "banner.home.button2.url" })
              }>
                <Button bgColor={"#F2F2F2"} bgHoverColor="#140F33">
                  <span>
                    {intl.formatMessage({ id: "banner.home.button2.text" }) + intl.formatMessage({ id: "banner.home.button2.url" })}
                  </span>
                  <Icon name="icon-phone"></Icon>
                </Button>
              </a> */}
              </>
            }
            customClass="grid-6"
          />
        ) : (
          <Content
            content={
              <div className="banner-top-icon">
                <div>
                  <AnimateIcon json={paymentLink} />
                </div>
                <p>Payment Links</p>
              </div>
            }
            title={intl.formatMessage({ id: "banner.payment.title" })}
            subtitle={intl.formatMessage({ id: "banner.payment.subtitle" })}
            footer={
              <>
                <a href="https://dashboard.etpay.com/sign-up">
                  <Button
                    bgColor={"#857BF9"}
                    bgHoverColor="#140F33"
                    color="#fff"
                  >
                    <Icon name={"Icon_Pre"} className="fillable" fill="#fff" />
                    <span>
                      {intl.formatMessage({ id: "button.testFree.text" })}
                    </span>
                  </Button>
                </a>
                <p>
                  o llámanos al{" "}
                  {activeCountry === "mx"
                    ? "+52 55 4169 7254"
                    : "+56 2 3210 1557"}
                </p>

                {/* <a href={
                'tel:' + intl.formatMessage({ id: "banner.home.button2.url" })
              }>
                <Button bgColor={"#F2F2F2"} bgHoverColor="#140F33">
                  <span>
                    {intl.formatMessage({ id: "banner.home.button2.text" }) + intl.formatMessage({ id: "banner.home.button2.url" })}
                  </span>
                  <Icon name="icon-phone"></Icon>
                </Button>
              </a> */}
              </>
            }
            customClass="grid-6"
          />
        )}
        <div
          className="image-banner"
          style={{
            gridColumn: "7 / 13",
            marginTop: 0,
          }}
        >
          <img src={getImages["banner_image_payment"]} alt="" />
        </div>
      </Banner>
      <section className="section-2">
        <div className="section2-content">
          <span style={{ color: color }}>
            {activeCountry === "mx"
              ? "Dónde y cuándo lo necesites"
              : "Dónde y cuándo lo necesites"}
          </span>
          <h4>
            {activeCountry === "mx"
              ? "Sin efectivo ni tarjeta."
              : "Sin efectivo ni tarjeta."}
          </h4>
          <p>
            {activeCountry === "mx"
              ? "Personaliza el envío de tus cobros a tus clientes. Los datos de la transacción están precargados en el enlace o código QR para que tu cliente autorice el pago."
              : "Personaliza el envío de tus cobros a tus clientes. Los datos de la transacción están precargados en el enlace o código QR para que tu cliente autorice el pago."}
          </p>
          <p>
            {activeCountry === "mx"
              ? "Recibe inmediatamente el dinero en tu cuenta bancaria."
              : "Recibe inmediatamente el dinero en tu cuenta bancaria."}
          </p>
        </div>
      </section>
      <div className="img-phone">
        <img src="/content/IMG_PL_mobile.png" alt="" />
      </div>
      <div>
        <Convertion
          color={color}
          topTitle={
            activeCountry === "mx" ? "Fácil de compartir" : "Multicanal"
          }
          title={
            activeCountry === "mx"
              ? "Adaptable a cualquier tipo de negocio"
              : "Adaptable a cualquier tipo de negocio"
          }
          description={
            activeCountry === "mx"
              ? "Envía el link de pago por correo electrónico o WhatsApp o pide a tu cliente que escanee el código QR"
              : "Ajustado a cada caso y cada necesidad, si necesitas enviar links de pago como que te paguen escaneando un QR."
          }
        >
          <Bubble>
            <div style={{ width: "100%" }}>
              {activeCountry === "mx"
                ? "Realizar el pago de tu compra en Mercado Fresco de $10,000 aquí"
                : "Realizar el pago de tu compra en Mercado Fresco de $10.000 aquí"}
              <a> https://link.pay</a>
            </div>
          </Bubble>
        </Convertion>
        <ConvertionBelow
          title={
            activeCountry === "mx"
              ? "En cualquier lugar"
              : "Funciona en cualquier situación"
          }
          description={
            activeCountry === "mx"
              ? "Tu cliente recibe por correo electrónico o mensaje de WhatsApp el enlace de pago. El dinero se envía automáticamente a tu cuenta."
              : "El cliente recibe un correo electrónico o  un mensaje de WhatsApp con el enlace listo para realizar el pago. El dinero se envía automáticamente a su cuenta."
          }
          list={
            <List customClass="list">
              <ItemList>
                <Icon name="Check2" />
                <p>
                  {intl.formatMessage({
                    id: "whatapp.paymentLink.list.item1",
                  })}
                </p>
              </ItemList>
              <ItemList>
                <Icon name="Check2" />
                <p>
                  {intl.formatMessage({
                    id: "whatapp.paymentLink.list.item2",
                  })}
                </p>
              </ItemList>
              <ItemList>
                <Icon name="Check2" />
                <p>
                  {intl.formatMessage({
                    id: "whatapp.paymentLink.list.item3",
                  })}
                </p>
              </ItemList>
              <ItemList>
                <Icon name="Check2" />
                <p>
                  {intl.formatMessage({
                    id: "whatapp.paymentLink.list.item4",
                  })}
                </p>
              </ItemList>
              <ItemList>
                <Icon name="Check2" />
                <p>
                  {intl.formatMessage({
                    id: "whatapp.paymentLink.list.item5",
                  })}
                </p>
              </ItemList>
            </List>
          }
        >
          {activeCountry === "mx" ? (
            <img
              style={{ width: "50%" }}
              className="show-desktop"
              src="/content/PaymentLinks_MX_02.jpg"
            />
          ) : (
            <video
              id="move-video-pay"
              className="show-desktop"
              style={{
                width: "45%",
                borderRadius: "35px",
                border: "1px solid #E6E6E6",
              }}
              autoPlay={true}
              muted={true}
              playsInline
              src={getImages["gif-payment-links-back"]}
              data-center-center=" transform: translate(0px,0px);"
              data-1950="transform: translate(0px,700px);"
            ></video>
          )}

          {activeCountry === "mx" ? (
            <img
              style={{ width: "75%", marginTop: "5rem" }}
              className="show-mobile"
              src="/content/PaymentLinks_MX_02.jpg"
            />
          ) : (
            <video
              className="show-mobile"
              style={{
                width: "75%",
                borderRadius: "35px",
                border: "1px solid #E6E6E6",
                marginTop: "5rem",
              }}
              autoPlay={true}
              muted={true}
              playsInline
              src={getImages["gif-payment-links-back"]}
            ></video>
          )}
        </ConvertionBelow>
        <EasyGestion></EasyGestion>
        {/* <PosibleWidthEtpay color={color}></PosibleWidthEtpay> */}
        <Tarifas />
        <ReadyToStart></ReadyToStart>
      </div>
    </Layout>
  );
};
